import { z } from "zod"

export const Environment = z.enum(["Development", "Production"])
export type TEnvironment = z.infer<typeof Environment>

export const EnvironmentConfigSchema = z.object({
  environment: Environment,
  api: z.object({
    baseURL: z.string().url(),
    remoteURL: z.string().url(),
    launcherURL: z.string().url(),
  }),
  dev: z.object({
    launcherIDCookie: z.string(),
    jSessionIDCookie: z.string(),
  }),
})
export type TEnvironmentConfig = z.infer<typeof EnvironmentConfigSchema>
